import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserResponse } from '@ph-model/login';

import { DealerRoutesRegistry } from '../../config/dealer-routes.config';
import { LoggerContext } from '../../enums/logger-context.enum';
import { ErrorService } from '../error/error.service';
import { LoggerService } from '../logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  private router = inject(Router);
  private logger = inject(LoggerService);
  private errorService = inject(ErrorService);

  navigateToContent(user?: UserResponse) {
    const route: string = localStorage.getItem('redirectUrl') || '/home';
    this.logger.log(LoggerContext.Router, { navigateToContent: route });
    
    if (DealerRoutesRegistry.isDealerProtectedRoute(route) && !user?.cmsDealerNumber) {
      this.logger.log(LoggerContext.Router, 'redirecting to home - user lacks dealer access for target route', { 
        targetRoute: route,
        hasDealerAccess: !!user?.cmsDealerNumber
      });
      this.navigateToHome();

      return;
    }
    
    void this.router.navigateByUrl(route);
  }

  navigateToHome() {
    this.logger.log(LoggerContext.Router, 'navigateToHome');
    void this.router.navigateByUrl('/home');
  }

  navigateToLogin() {
    this.logger.log(LoggerContext.Router, 'navigateToLogin');
    void this.router.navigate(['/login']);
  }

  navigateToCallback() {
    this.logger.log(LoggerContext.Router, 'navigateToCallback');
    void this.router.navigate(['/callback']);
  }

  navigateToCallbackError(message: string): void {
    this.logger.log(LoggerContext.Router, 'navigateToCallbackError', { message });
    this.errorService.displayErrorMessage(0, message);
    void this.router.navigate(['/callback/error']);
  }

  /**
   * Cross-portal conflict page. The embedded Okta widget cannot render a login form while a
   * foreign IdP session cookie is alive, so the user must close it via "End all sessions" first.
   */
  navigateToSsoConflict(): void {
    this.logger.log(LoggerContext.Router, 'navigateToSsoConflict');
    this.errorService.displaySsoError('CROSS_PORTAL_CONFLICT');
    void this.router.navigate(['/callback/error']);
  }
}
